module.exports = __webpack_public_path__ + "static/media/20_tn.fa4dfce9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/polished/thumbnails/20_tn.jpg
// module id = 508
// module chunks = 0